import React, { FunctionComponent as FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'; // To call Action Creators
import { State } from "../../../../state";
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../../../state';
import _ from 'lodash';
import './index.scss';

import logoUrl from '../../../../assets/XRP.svg';
import { viewSize, themeColor } from "../../../../types/style.global";
import { ImpactType, CitationFlowType, GrantGlyphType } from '../../../../types/data.global';

import {
  CaretDownOutlined,
  CaretUpOutlined,
  SearchOutlined, BarChartOutlined, AreaChartOutlined, TableOutlined, BankOutlined, UsergroupAddOutlined
} from '@ant-design/icons';
import { Select, Switch, ConfigProvider, Slider } from 'antd';
const { Option } = Select;


interface PanelProps {
  viewTitle: string;
  width: string | number;
  height: string | number;
  margin: number;
  padding: number;
  panelHeaderHeight: number;
  children: React.ReactNode; // 👈️ added type for children
  historicalRef?: React.RefObject<HTMLDivElement>;
}

const Panel: FC<PanelProps> = (props) => {

  const { viewTitle, width, height, margin, padding, panelHeaderHeight, historicalRef } = props

  const dispatch = useDispatch()
  const {
    updateCitationFlowType,
    updateImpactType,
    updateImpactStatisticsTypeList,
    updateGrantGlyphType,
    updateTopKEntityField,
    updateTopKCitationFlow,
    setShowEntityFieldLevelGraph,
    setShowEntityTypeLevelGraph,
    // updateIsEntityFieldGraphFinished,
    updateIsInitializeBubbleTreemapFinished,
    updateIsOptimizedBubbleTreemapFinished,
    updateIsEntityTypeGraphFinished,
    cleanMainviewGraph,
    clearCheckboxSelection,
    updateSelectedImpactEntityField,
    onClickGrantFieldNode,
    onClickImpactFieldNode,
    updateHighlghtedGrantFieldID,
    isShowLeafNode,
    isShowPredictionFlow,
    isShowHistoricalFlow,
    isShowHistoricalGraph,
    isShowPredictionGraph,
    setQueryViewFolded, // 添加这个action creator

    updateEntityTypeLayoutData,
    updateLeafNodeSizeScale,
    updateLeafNodeInitialPositionList,
    updateBubbleTreemapEntityGroupList,
    updateBubbleTreemapGeometryGroup,
    updateWordlePosition,
    updateWordleEntity,
    isShowWordle,
    updatePredictionSearchResult,
    updatePredictionGrantIDList4PIView,
    updateLeafNodePositionList,
    updateEntityFieldGraph_InputData,
    updateGrantFieldNodePosition,
    updateNodePositionList,
  } = bindActionCreators(actionCreators, dispatch)

  const isQueryViewFolded: boolean = useSelector((state: State) => state.uiReducer?.isQueryViewFolded) as boolean
  const currentImpactType: string = useSelector((state: State) => state.uiReducer?.impactType) as string
  const citationFlowType: string = useSelector((state: State) => state.uiReducer?.citationFlowType) as string

  // 1. state variables - 移除本地状态，直接使用Redux状态
  const toggleFold = () => {
    // 手动点击时，更新Redux状态而不是本地状态
    setQueryViewFolded(!isQueryViewFolded);
  }

  // 2. jsx elements
  // 2-1. icon
  let iconElement: JSX.Element = <></>
  switch(viewTitle) {
    case 'Query View':
      iconElement = <SearchOutlined />
      break;
    case 'Grant View':
      iconElement = <BarChartOutlined />
      break;
    case 'PI View':
      iconElement = <UsergroupAddOutlined/>
      break;
    case 'Impact Landscape View':
      iconElement = <img src={logoUrl} alt="Description of image" style={{ height: 20, marginRight: 2 }}/>
      break;
    case 'Impact Type View':
      iconElement = <AreaChartOutlined />
      break;
    case 'Impact Entity View':
      iconElement = <TableOutlined />
      break;
    default:
      break;
  }
  // 2-2. slider & switch
  const handleChangeCitationFlowTypeDropdown = (value: string) => {
    // console.log(`selected ${value}`);
    updateCitationFlowType(value);

    // update css in leaf node
    isShowLeafNode(true)

    updateSelectedImpactEntityField({})

    // clear up historical selected (1) citation flow (2) highlight node
    onClickGrantFieldNode({
      grantFieldID: '',
      grantFieldName: '',
      impactType: currentImpactType,
      // impactType: ImpactType.DIRECT_IMPACT,
    })
    // clear highlighted impact field node
    onClickImpactFieldNode({
      impactType: '',
      impactEntity: '',
      impactFieldID: '',
    })
    updateHighlghtedGrantFieldID('all')

    if (value === CitationFlowType.HISTORICAL) {
      // console.log('historical flow-------')
      isShowPredictionFlow(false) // 从impact entity field出发画flow
      isShowHistoricalFlow(true) // 从grant_field出发画flow。本质flow是一样的，只是highlight的flow不一样

      isShowPredictionGraph(false)
      isShowHistoricalGraph(true)
    } else if (value === CitationFlowType.PREDICTION) {
      // console.log('prediction flow-------')
      isShowPredictionFlow(true)
      isShowHistoricalFlow(false)

      isShowPredictionGraph(true)
      isShowHistoricalGraph(false)
    } else {
      console.log(`error in flow type: ${value}`);
    }
  }
  const handleChangeImapctTypeDropdown = (value: string) => {
    // clear everything then start over again

    console.log(`selected ${value}`);

    // clear checkbox selection
    updateImpactStatisticsTypeList([]); // clear all impact type
    updateImpactType(value);

    // clear ui reducer: mainview graph
    setShowEntityTypeLevelGraph(false);
    setShowEntityFieldLevelGraph(false);
    updateIsEntityTypeGraphFinished(false);
    isShowHistoricalGraph(true);
    isShowPredictionGraph(false);
    updateHighlghtedGrantFieldID('all');
    isShowLeafNode(true);
    // updateIsEntityFieldGraphFinished(false);
    updateIsInitializeBubbleTreemapFinished(false);
    updateIsOptimizedBubbleTreemapFinished(false);
    cleanMainviewGraph(true);
    isShowWordle(false);
    isShowPredictionFlow(false);
    isShowHistoricalFlow(false);
    updateCitationFlowType(CitationFlowType.HISTORICAL);

    // clear data reducer: all data stored in redux about mainview calc should be cleared
    updateEntityTypeLayoutData([]);
    updateLeafNodeSizeScale(0, '');
    // store leaf node positions to state - for drawing edges
    updateLeafNodeInitialPositionList({
      leafNodePositionList: [],
      bubbleTreemapEntityTypeCenterXYList: [],
    });
    updateBubbleTreemapEntityGroupList([]);
    updateBubbleTreemapGeometryGroup([]);
    updateWordlePosition({
      left: 0,
      top: 0,
    });
    updateWordleEntity({
      entity: '',
      fieldID: '',
    });
    updateSelectedImpactEntityField({});
    updatePredictionSearchResult({
      entity: '',
      fieldIDList: [],
    });
    // updatePredictionGrantIDList4PIView([], []);
    // clear up historical selected (1) citation flow (2) highlight node
    onClickGrantFieldNode({
      grantFieldID: '',
      grantFieldName: '',
      impactType: value,
    })
    // clear highlighted impact field node
    onClickImpactFieldNode({
      impactType: '',
      impactEntity: '',
      impactFieldID: '',
    })

    // component: OptimizedBubbleTreemap
    updateLeafNodePositionList({
      leafNodePositionList: [],
      bubbleTreemapEntityTypeCenterXYList: [],
    });
    updateEntityFieldGraph_InputData([]);

    // component: GrantTypeNode
    updateGrantFieldNodePosition({
      grantNodePositionList: [],
      isDrawGrantTypeNodeFinished: false,
    })

    // component: EntityFieldLevelCitationFlow
    updateNodePositionList([]);


    // // clear all selection of checkbox
    // clearCheckboxSelection(true)
  }
  const handleChangeGrantGlyphTypeDropdown = (value: string) => {
    // console.log(`selected ${value}`);
    updateGrantGlyphType(value)
  }
  const handleTopKFieldSliderChange = (value: number) => {
    // console.log(`topKFieldSlider value: ${value}`);
    updateTopKEntityField(value)
  }
  const handleCitationFlowSliderChange = (value: number) => {
    // console.log(`topKCitationFlowSlider value: ${value}`);
    updateTopKCitationFlow(value)
  }
  const citationFlowTypeDropdownMenu: JSX.Element = <div ref={historicalRef}>
    <Select
      value={citationFlowType}  // 使用Redux状态作为当前值
      // defaultValue={CitationFlowType.HISTORICAL}
      style={{ maxWidth: 120, height: 24 }}
      // style={{ width: 200, height: 26 }}
      onChange={handleChangeCitationFlowTypeDropdown}
      size="small"
    >
      <Option value={CitationFlowType.HISTORICAL}>{CitationFlowType.HISTORICAL}</Option>
      <Option value={CitationFlowType.PREDICTION}>{CitationFlowType.PREDICTION}</Option>
    </Select>
  </div>

  const impactTypeDropdownMenu: JSX.Element = <Select
                                                defaultValue={ImpactType.INDIRECT_IMPACT_FOLDED}
                                                // defaultValue={ImpactType.DIRECT_IMPACT}
                                                style={{ maxWidth: 120, height: 24 }}
                                                onChange={handleChangeImapctTypeDropdown}
                                                // onSelect={handleChangeImapctTypeDropdown}
                                                size="small"
                                              >
                                                <Option value={ImpactType.DIRECT_IMPACT}>Direct Outcome</Option>
                                                <Option value={ImpactType.INDIRECT_IMPACT_FOLDED}>Broader Impact</Option>
                                                {/* <Option value={ImpactType.INDIRECT_IMPACT_UNFOLDED}>Broad Impact (unfolded)</Option> */}
                                              </Select>
  const grantGlyphType: JSX.Element = <Select defaultValue={GrantGlyphType.RCIGLYPH} style={{ width: 160, height: 26 }} onChange={handleChangeGrantGlyphTypeDropdown}>
                                                      <Option value={GrantGlyphType.RCIGLYPH}>{GrantGlyphType.RCIGLYPH}</Option>
                                                      <Option value={GrantGlyphType.IMPACTCOUNTGLYPH}>{GrantGlyphType.IMPACTCOUNTGLYPH}</Option>
                                                      <Option value={GrantGlyphType.PREDICTIONGLYPH}>{GrantGlyphType.PREDICTIONGLYPH}</Option>
                                                    </Select>
  const topKFieldSlider: JSX.Element = <div className='slider-div'>
                                        <div style={{width: 100}}>Top k Fields: </div>
                                        <Slider style={{width: 100}} min={1} max={30} defaultValue={10} onAfterChange={handleTopKFieldSliderChange} />
                                      </div>
  let topKFlowSlider: JSX.Element = <div className='slider-div'>
                                      <div style={{width: 100}}>Top k flow: </div>
                                      <Slider style={{width: 100}} min={1} max={30} defaultValue={6} onAfterChange={handleCitationFlowSliderChange} />
                                    </div>
  let predictionScoreSlider: JSX.Element = <></>


  // 3. style - 直接使用Redux状态
  let style: any = {
    width: `calc(${width} - ${margin * 2}px)`,
    height: `calc(${height} - ${margin * 2}px)`,
    margin: margin,
    padding: padding,
  }
  if (viewTitle === 'Query View' && isQueryViewFolded) {
    style = {
      width: `calc(${width} - ${margin * 2}px)`,
      height: Number(viewSize.queryViewFolded.height) - margin,
      margin: margin,
      padding: padding,
    }
  }


  return (
    <div className='panel' style={style}>
      <div className='panel-header' style={{height: panelHeaderHeight}}>
        <div className='left-align'>
          <span className='panel-icon'>{iconElement}</span>
          <span className="panel-title">{viewTitle}</span>
        </div>
        {/* 简化折叠/展开图标的显示逻辑 */}
        {(viewTitle) === 'Query View' && isQueryViewFolded &&
          <CaretDownOutlined style={{ fontSize: '16px', color: themeColor.defaultMode.colorPrimary, marginRight: '16px'}}
            onClick={toggleFold}
          />
        }
        {(viewTitle) === 'Query View' && !isQueryViewFolded &&
          <CaretUpOutlined style={{ fontSize: '16px', color: themeColor.defaultMode.colorPrimary, marginRight: '16px'}}
            onClick={toggleFold}
          />
        }
        {(viewTitle) === 'Impact Type View' &&
          <ConfigProvider
            theme={{
              token:{
                colorPrimary: '#7F5539',
              },
              components: {
                Form: {
                  labelFontSize: 15,
                  itemMarginBottom: 2,
                },
                Radio: {

                }
              }
            }}
          >
            <div className='right-align' style={{width: 164}}>
              <div className='dropdown-menu'>{impactTypeDropdownMenu}</div>
            </div>
          </ConfigProvider>
        }
        {(viewTitle) === 'Impact Landscape View' &&
          <ConfigProvider
            theme={{
              token:{
                colorPrimary: '#7F5539',
              },
              components: {
                Form: {
                  labelFontSize: 15,
                  itemMarginBottom: 2,
                },
                Radio: {

                }
              }
            }}
          >
            <div className='right-align'>
              {/* <div className='dropdown-menu'>{impactTypeDropdownMenu}</div> */}
              <div className='dropdown-menu'>{citationFlowTypeDropdownMenu}</div>
              {/* <div className='dropdown-menu'>{grantGlyphType}</div> */}
              {/* <div className='dropdown-menu'>{topKFieldSlider}</div> */}
              <div className='dropdown-menu'>{topKFlowSlider}</div>
            </div>
          </ConfigProvider>
        }
      </div>
      {/* 简化panel-body的条件渲染 */}
      {((viewTitle) === 'Query View') && isQueryViewFolded &&
        <div className='panel-body' style={{height: `calc(${viewSize.queryViewFolded.height} - ${panelHeaderHeight}px)`}}>{props.children}</div>
        // <div className='panel-body' style={{height: viewSize.queryViewFolded.height - panelHeaderHeight}}>{props.children}</div>
      }
      {((viewTitle) === 'Query View') && !isQueryViewFolded &&
        <div className='panel-body' style={{height: `calc(${viewSize.queryView.height} - ${panelHeaderHeight}px)`}}>{props.children}</div>
        // <div className='panel-body' style={{height: viewSize.queryView.height - panelHeaderHeight}}>{props.children}</div>
      }
      {((viewTitle) !== 'Query View') &&
        <div className='panel-body' style={{height: `calc(${height} - ${panelHeaderHeight}px)`}}>{props.children}</div>
        // <div className='panel-body' style={{height: height - panelHeaderHeight}}>{props.children}</div>
      }
    </div>
  )
}

export default Panel